module.exports = __webpack_public_path__ + "frontend-assets/img/exit_new_button.675032a6.png";